import CardUser from "../../../components/CardUser";
import CardNews from "../../../components/CardNews";
import HistoricOrders from "../../../components/CardHistoric";
import DeliveryTimeLine from "../../../components/DeliveryTimeline";
import CardCalendar from "../../../components/CardCalendar";
import StatusHome from "../../../components/StatusHome";

const Home = () => {
  return (
    <>
      <div className="grid grid-cols-12">
        <CardUser />

        <CardNews />
      </div>

      <div className="mt-2 flex">
        <div className="flex min-w-full">
          <div className="grid grid-cols-2 w-full lg:grid-cols-12">
            <div className="flex col-span-9">
              <div className="grid grid-cols-2 w-full">
                <HistoricOrders />
                <DeliveryTimeLine />
              </div>
            </div>

            <CardCalendar />
          </div>
        </div>
      </div>

      <StatusHome />
    </>
  );
};

export default Home;
